import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { SOIL_RISK_COLOR } from '../const/color';

const TooltipRiskScatter = (props) => {
    const title = React.useMemo(() => {
        switch (props.tooltipKey) {
            case 'scatter_rain_h1_h24':
            case 'scatter_rain_h1_dc_tank':
                return '字名';
            case 'scatter_rain_h1_dc_tank_city':
                return '市町村名';
            case 'heatmap_rain_city':
                return '警報基準相当';
            default:
                return '';
        }
    }, [props.tooltipKey]);

    return (
        <Box sx={{ width: 220, bgcolor: 'background.paper', borderRadius: 2, overflow: 'hidden' }} >
            <Box sx={{ p: 1 }}>
                <Typography variant="subtitle2" sx={{ fontSize: '14px', fontWeight: 'bold', mb: 0.5, color: 'text.secondary' }}> {title} </Typography>
                <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 'bold', color: 'text.primary' }}>
                    {props?.tooltipInfo?.data?.name}
                </Typography>
                <Divider sx={{ borderColor: '#323232' }} />
            </Box>
            <Box sx={{ p: 1 }}>
                {props?.renderBody(props.tooltipKey, props.tooltipInfo)}
                <Box sx={{ mt: 1 }}>
                    <Box sx={{ position: 'relative' }}>
                        <Box sx={{
                            position: 'absolute',
                            left: `${(props?.tooltipInfo?.data?.soil_index_level - 1) * 20}%`,
                            top: -4,
                            width: 4,
                            height: 16,
                            bgcolor: "#323232",
                            borderRadius: 1,
                            zIndex: 99
                        }} />
                    </Box>
                    <Box sx={{ display: 'flex', height: 8, overflow: 'hidden', mb: 0.5 }} >
                        {Object.values(SOIL_RISK_COLOR).map((item, index) => (
                            <Box key={index} sx={{ flex: 1, bgcolor: item.color, height: 16 }} />
                        ))}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {['-∞', '2', '3', '4', '5', '+∞'].map((label, index) => (
                            <Typography key={index} variant="caption" sx={{ fontSize: '10px', color: 'text.disabled' }} >
                                {label}
                            </Typography>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default TooltipRiskScatter;